import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchCandidateSubscriptionsPaymentCheckAsync, selectCandidateSubscriptions } from "../CandidateSubscriptions/CandidateSubscriptionsSlice";

function PaymentInitiate() {
  const location = useLocation();
  const { uuid } = location.state || {};
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const data = useSelector(selectCandidateSubscriptions);
  const [countdown, setCountdown] = useState(5); // Initial countdown value

  useEffect(() => {
    if (uuid) {
      dispatch(fetchCandidateSubscriptionsPaymentCheckAsync(uuid));
    }
  }, [uuid, dispatch]);

  useEffect(() => {
    if (data) {
      const interval = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);

      const timer = setTimeout(() => {
        navigate("/candidate-dashboard/subscription-billings");
      }, 5000); // Redirect after 10 seconds 

      return () => {
        clearInterval(interval);
        clearTimeout(timer);
      };
    }
  }, [data, navigate]);

  if (!data || Object.keys(data).length === 0) {
    return <h2>Something went wrong. Try again.</h2>;
  }

  if (data.status === "pending") {
    return <h2>Pending...</h2>;
  }

  return (
    <div className="flex flex-col justify-center items-center text-center">
      <h1 className="my-4">Payment Successful 🎉</h1>
      <p>
        <strong>Transaction ID:</strong> {data?.txnid}
      </p>
      <p>
        <strong>Order ID:</strong> {data?.order_id}
      </p>
      <p>
        <strong>Payment ID:</strong> {data?.payment_id}
      </p>
      <p>
        <strong>Status:</strong> {data?.status}
      </p>
      <p>
        <strong>Total Amount:</strong> ₹{data?.total_amount}
      </p>
      <p className="mt-4 text-gray-600">
        Redirecting to Subscription Details in {countdown} seconds...
      </p>
    </div>
  );
}

export default PaymentInitiate;
